const Currency = {
  EUR: 'EUR',
  USD: 'USD',
};

const CurrencySymbol = {
  EUR: '€',
  USD: '$',
};

export const getCurrencySymbol = (currencyCode) => CurrencySymbol[currencyCode] || currencyCode;

export default Currency;
